import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { UserX } from 'lucide-react';
import { authClient } from '../lib/authClient';
import { clearSessionData } from '../utils/clearSessionData';

// Where AuthSync sends someone whose band removed them mid-session. They're signed out here,
// so the next sign-in starts clean (setting up their own band, or opening a new invite link).
export default function RemovedFromBand() {
  const { state } = useLocation();
  const bandName = state?.bandName;
  const [signedOut, setSignedOut] = useState(false);

  useEffect(() => {
    authClient.signOut()
      .catch(() => {})
      .then(clearSessionData)
      .catch(() => {})
      .finally(() => setSignedOut(true));
  }, []);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={styles.icon}><UserX size={28} color="#667eea" /></div>
          <h1 style={styles.title}>You've been removed from {bandName || 'the band'}</h1>
          <p style={styles.muted}>
            The band's owner has taken this login off {bandName || 'their band'}, so you can't see its songs,
            gigs or set lists any more. If that's a mistake, ask them to send you a new invite link.
          </p>
        </div>
        <Link to="/" style={styles.primary}>Go to the GigRequest home page</Link>
        {signedOut && (
          <p style={{ ...styles.muted, fontSize: 12, marginTop: 14, textAlign: 'center' }}>
            You've been signed out.
          </p>
        )}
      </div>
    </div>
  );
}

const button = {
  display: 'block', width: '100%', padding: 12, borderRadius: 8, fontSize: 15, fontWeight: 600,
  textAlign: 'center', textDecoration: 'none', cursor: 'pointer', boxSizing: 'border-box',
};
const styles = {
  page: {
    minHeight: '100vh', background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a3e 100%)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  card: {
    width: '100%', maxWidth: 440, background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)', borderRadius: 16, padding: '40px 36px', boxSizing: 'border-box',
  },
  icon: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56,
    background: 'rgba(102,126,234,0.2)', borderRadius: 14, marginBottom: 16,
  },
  title: { margin: '0 0 8px', fontSize: 22, fontWeight: 700, color: '#fff' },
  muted: { margin: 0, fontSize: 14, lineHeight: 1.5, color: 'rgba(255,255,255,0.6)' },
  primary: { ...button, border: 'none', color: '#fff', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
};
